class Hero extends HTMLElement {
  connectedCallback() {
    const mobileMatchMedia = window.matchMedia('(max-width: 960px)');
    mobileMatchMedia.addEventListener('change', this.toggleHeightPinning.bind(this));
    this.toggleHeightPinning(mobileMatchMedia);

    this.addVideoControlListeners();
    this.addVolumeControlListeners();
  }

  toggleHeightPinning(mql) {
    if (mql.matches) {
      this.style.maxHeight = window.innerHeight + 'px';
    } else {
      this.style.maxHeight = '';
    }
  }

  addVideoControlListeners() {
    const pauseButtons = this.querySelectorAll('.js-video-action');
    pauseButtons.forEach((button) => {
      button.addEventListener('click', this.togglePlayPauseVideo.bind(this, button));
    });
  }

  addVolumeControlListeners() {
    const volumeButtons = this.querySelectorAll('[volume]');
    volumeButtons.forEach((button) => {
      button.addEventListener('click', this.toggleVolume.bind(this, button));
    });
  }

  togglePlayPauseVideo(button) {
    const videoId = button.getAttribute('data-video-id');
    const videoElement = document.getElementById(videoId);

    if (videoElement) {
      if (videoElement.paused) {
        videoElement.play();
        this.changeIcon(button, 'pause');
      } else {
        videoElement.pause();
        this.changeIcon(button, 'play');
      }
    }
  }

  toggleVolume(button) {
    const videoId = button.getAttribute('data-video-id');
    const videoElement = document.getElementById(videoId);

    if (videoElement) {
      videoElement.muted = !videoElement.muted;
      button.querySelectorAll('span').forEach((span) => {
        span.classList.toggle('hidden');
      });
    }
  }

  changeIcon(button, action) {
    if (action === 'play') {
      button.querySelector('.icon-play').classList.remove('hidden');
      button.querySelector('.icon-pause').classList.add('hidden');
    } else if (action === 'pause') {
      button.querySelector('.icon-play').classList.add('hidden');
      button.querySelector('.icon-pause').classList.remove('hidden');
    }
  }
}

customElements.define('hero-banner', Hero);
